import { z } from "zod"

const TriggerSchema = z.object({
  type: z.enum(["segment_enter", "segment_exit"]),
  segment: z.string(),
})

const DelayStepSchema = z.object({
  type: z.literal("delay"),
  unit: z.enum(["minutes", "hours", "days"]),
  duration: z.number(),
})

const EmailStepSchema = z.object({
  type: z.literal("email"),
  template: z.string(),
})

const PushStepSchema = z.object({
  type: z.literal("push"),
  title: z.string(),
  content: z.string(),
})

const ConditionStepSchema = z.object({
  type: z.literal("condition"),
  performed_event: z.string(),
  should_exit: z.boolean(),
})

const StepSchema = z.union([DelayStepSchema, EmailStepSchema, PushStepSchema, ConditionStepSchema])

export const CampaignSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  trigger: TriggerSchema,
  steps: z.array(StepSchema),
})

export type Campaign = z.infer<typeof CampaignSchema>
